"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function SvgComponent(props) {
    const { fill = 'none' } = props, restProps = __rest(props, ["fill"]);
    return (react_1.default.createElement("svg", Object.assign({ "aria-hidden": 'true', focusable: 'false', className: `fl-${fill}`, width: 32, height: 32, viewBox: '0 0 32 32', xmlns: 'http://www.w3.org/2000/svg' }, restProps),
        react_1.default.createElement("path", { d: 'M15.5 32C18.2614 32 20.5 31.1046 20.5 30C20.5 28.8954 18.2614 28 15.5 28C12.7386 28 10.5 28.8954 10.5 30C10.5 31.1046 12.7386 32 15.5 32Z', fillOpacity: 0.04 }),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M15.5 0C20.7467 0 25 4.24151 25 9.47368C25 14.1904 21.5435 18.102 17.0187 18.827C16.9237 18.8422 16.7992 18.8588 16.6455 18.8766C16.4438 18.9001 16.2917 19.0709 16.2917 19.274L16.2917 29.2083C16.2917 29.6456 15.9372 30 15.5 30C15.0628 30 14.7083 29.6456 14.7083 29.2083L14.7083 19.274C14.7083 19.071 14.5561 18.9002 14.3544 18.8767C14.2045 18.8593 14.0829 18.8432 13.9898 18.8283C9.46085 18.1069 6 14.1933 6 9.47368C6 4.24151 10.2533 0 15.5 0Z' })));
}
exports.default = SvgComponent;
